export const IntroSection = () => (
  <section>
    <h2>Your privacy is important to us</h2>

    <p>
      Volca ("Volca", "we", "our" or "us") puts great efforts in making sure
      that the personal data processed by us is safe and used properly, and that
      our data practices are properly communicated to our customers, users and
      prospects.
    </p>

    <p>
      This Privacy Policy describes how we collect, store, use and disclose the
      following types of personal data:
    </p>

    <ul>
      <li>
        (i) Customer Data: data relating to identifiable individuals ("Personal
        Data"), which we analyze, process and manage on our customers' behalf
        ("Services"). Specifically, this is data which is contained in call
        recordings, transcripts, and other communications and content, as well
        as data submitted by our customers (including by connecting their
        systems with the Services);
      </li>
      <li>
        (ii) Volca User Data: account, contact and activity data relating to
        individuals who use the Volca platform, mobile application, and other
        tools and features provided by us as part of the Services (collectively
        – "Platform");
      </li>
      <li>
        (iii) Volca Website, CRM & Prospect Data: data relating to our
        customers, visitors of our website (www.govolca.com), participants at
        our events, and any other prospective customer or partner who visits or
        otherwise interacts with any of our websites, online ads and content,
        emails or communications under our control ("Sites").
      </li>
    </ul>

    <p>Specifically, this Privacy Policy describes our practices regarding –</p>

    <ul>
      <li>Data Collection & Processing</li>
      <li>Data Uses</li>
      <li>Data Location</li>
      <li>Data Retention</li>
      <li>Data Sharing</li>
      <li>Cookies and Tracking Technologies</li>
      <li>Communications</li>
      <li>Data Security</li>
      <li>Data Subject Rights</li>
      <li>Data Controller/Processor</li>
      <li>Additional Notice & Contact Details</li>
    </ul>

    <p>
      If you are our customer, user, visitor or prospect ("you"), please read
      this Privacy Policy carefully and make sure that you fully understand and
      agree to it.
    </p>

    <p>
      You are not legally required to provide us with any personal data, and may
      do so (or avoid doing so) at your own free will. If you do not wish to
      provide us with your personal data, or to have it processed by us or any
      of our Service Providers (defined below), please avoid any interaction
      with us or use of our Services. If you are a user of the Platform on
      behalf of any of our customers, we suggest that you contact your account
      administrator with any questions.
    </p>
  </section>
);
